import React from 'react';
import { ErrorDisplay } from './alerts';

/**
 * Represents a small (to embbed) red error alert message with description facilities
 */
type PropsType = {
    error;
};

export function RedLabel({ error }: PropsType) {
    return (
        <div className="w3-panel w3-pale-red w3-border w3-center">
            <ErrorDisplay error={error} />
        </div>
    );
}
